import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MultiSelect } from "primereact/multiselect";
import CardsWidget from "../../../components/ProjectDashboard/CardsWidget";
import CategoryInfo from "../../../components/ProjectDashboard/CategoryInfo";
import ProgressBar from "../../../components/ProjectDashboard/ProgressBar";
import { useProjectDashboard } from "../../../Hooks/Features/ProjectDashboard/useProjectDashboard";
import PanelHeaderTemplate from "../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import CommonDropdown from "../../../components/CommonCompo/CommonDropdown/CommonDropdown";
import { Dropdown } from "primereact/dropdown";
import TaskReport from "../../../components/ProjectDashboard/TaskReport";
import TimeSpentTask from "../../../components/ProjectDashboard/TimeSpentTask";
import IssueTypeSummary from "../../../components/ProjectDashboard/IssueTypeSummary";
import TaskStatusTrendSummary from "../../../components/ProjectDashboard/TaskStatusTrendSummary";
import { useCommon } from "../../../Hooks/Common/useCommon";


const ProjectDashboard = () => {
  const { options, projectFilter, setProjectFilter, handleChange, projectOpts, handleClear, getSelectedValues, handleEmpty, tagRef } = useProjectDashboard();
  const { checkPermission } = useCommon();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

  return (
    <div ref={() => checkPermission("helpdesk", tagRef)}>
      <div className="project-dashboard" ref={tagRef} id='{"tabname": "project dashboard", "data": "project_dashboard_tab"}'>
        <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2 mb-3">
          <div className="d-flex align-items-center gap-2 flex-grow-1">
            <h5 className="mb-0">Project Dashboard</h5>
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <button className="sk-btn sk-btn-primary" onClick={() => setProjectFilter(prev => ({ ...prev, apiCall: true }))} title="Refresh">
              <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
            </button>
            <button className="sk-btn sk-btn-primary" onClick={() => setShowFiltersDrawer(true)} title="Filters">
              <FontAwesomeIcon icon="fa-solid fa-filter" />
            </button>
          </div>
        </div>

        <CardsWidget />
        <ProgressBar />
        <div className="row">
          <div className="col-lg-4 col-12" style={{ height: "35vh" }}>
            <CategoryInfo />
          </div>
          <div className="col-lg-3 col-12" style={{ height: "35vh" }}>
            <TaskStatusTrendSummary />
          </div>
          <div className="col-lg-5 col-12" style={{ height: "35vh" }}>
            <IssueTypeSummary />
          </div>
          <div className="col-lg-3 col-12" style={{ height: "35vh" }}>
            <TaskReport />
          </div>
          <div className="col-lg-9 col-12" style={{ height: "35vh" }}>
            <TimeSpentTask projectOpts={projectOpts} />
          </div>
        </div>

        {/* Right Panel Filters Drawer */}
        <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
          <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
            <div className="sk-drawer-header">
              <h5 className="sk-drawer-title">Filters</h5>
              <div className="d-flex align-items-center gap-2">
                <button className="sk-drawer-clear-btn" onClick={() => {
                  setProjectFilter((prev) => ({
                    ...prev,
                    client_id: null,
                    project_ids: [],
                    lead_user_code: null,
                    request_user_code: null,
                    project_module_ids: [],
                    feature_ids: [],
                    issue_id: "",
                    apiCall: true
                  }));
                }}>Clear All</button>
                <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                  <FontAwesomeIcon icon="fa-solid fa-xmark" />
                </button>
              </div>
            </div>
            <div className="sk-drawer-body">
              <div className='d-flex flex-column gap-4'>
                {/* Client Dropdown */}
                <div className="sk-drawer-filter-group">
                  <div className="task-list-filter-label">Client</div>
                  <Dropdown
                    onChange={handleChange}
                    options={options?.clientOptions}
                    filter
                    filterInputAutoFocus
                    placeholder="Select Client"
                    value={projectFilter?.client_id}
                    optionLabel="client_name"
                    name="client_id"
                    showClear
                    className="w-100"
                  />
                </div>

                {/* Project Multiselect */}
                <div className="sk-drawer-filter-group">
                  <div className="task-list-filter-label">Project</div>
                  <MultiSelect
                    placeholder='Select Project'
                    options={projectOpts}
                    value={projectFilter?.project_ids}
                    onChange={handleChange}
                    optionLabel='project_name'
                    filter filterInputAutoFocus
                    name="project_ids"
                    className="w-100"
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'project_ids', projectFilter?.project_ids, () => { }, handleClear)}
                  />
                </div>

                {/* Lead Dropdown */}
                <div className="sk-drawer-filter-group">
                  <div className="task-list-filter-label">Lead</div>
                  <Dropdown
                    onChange={handleChange}
                    options={options?.leadOptions}
                    filter
                    filterInputAutoFocus
                    placeholder="Select Lead"
                    value={projectFilter?.lead_user_code}
                    optionLabel="user_display_name"
                    name="lead_user_code"
                    showClear
                    className="w-100"
                  />
                </div>

                {/* Users Dropdown */}
                <div className="sk-drawer-filter-group">
                  <div className="task-list-filter-label">Users</div>
                  <Dropdown
                    onChange={handleChange}
                    options={options?.userOptions}
                    filter
                    filterInputAutoFocus
                    placeholder="Select User"
                    value={projectFilter?.request_user_code}
                    optionLabel="label"
                    name="request_user_code"
                    showClear
                    className="w-100"
                  />
                </div>

                {/* Project Module */}
                <div className="sk-drawer-filter-group">
                  <div className="task-list-filter-label">Project Module</div>
                  <CommonDropdown
                    placeholder='Select Module'
                    value='project_module'
                    selectedValues={getSelectedValues}
                    isFilterChange={projectFilter?.isProjectChange}
                    selectedProject={projectFilter?.project_ids}
                    projectFilter={handleEmpty}
                    className="w-100"
                  />
                </div>

                {/* Feature */}
                <div className="sk-drawer-filter-group">
                  <div className="task-list-filter-label">Feature</div>
                  <CommonDropdown
                    placeholder='Select Feature'
                    value='epic'
                    selectedValues={getSelectedValues}
                    isFilterChange={projectFilter?.isProjectChange}
                    selectedProject={projectFilter?.project_ids}
                    projectFilter={handleEmpty}
                    className="w-100"
                  />
                </div>

                {/* Issue key */}
                <div className="sk-drawer-filter-group">
                  <div className="task-list-filter-label">Issue Key</div>
                  <input
                    type="text"
                    value={projectFilter?.issue_id || ""}
                    onChange={handleChange}
                    name="issue_id"
                    placeholder="Enter Issue Key"
                    className="input-text w-100"
                  />
                </div>
              </div>
            </div>
            <div className="sk-drawer-footer">
              <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                setProjectFilter(prev => ({ ...prev, apiCall: true }));
                setShowFiltersDrawer(false);
              }}>Apply Filters</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProjectDashboard